import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, ExternalLink } from 'lucide-react';

const HealofyGallery = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <section className="pt-10 pb-20">
      <div className="container mx-auto px-6 md:px-12 max-w-6xl">
        <div className="mb-8">
          <div className="flex items-baseline justify-between mb-3">
            <div className="flex items-center gap-3">
              <h2 className="text-xl font-semibold text-neutral-900 font-display">Healofy</h2>
              <span className="text-[9px] font-mono text-accent bg-accent/10 px-2 py-0.5 rounded-full uppercase tracking-wider">E-commerce</span>
            </div>
            <span className="text-sm font-mono text-neutral-400">2019 – 2021</span>
          </div>
        </div>

        <motion.div 
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="w-full"
        >
          {/* Card 1: Vernacular Growth - Single Card with Edge-to-Edge Image & Padding */}
          <motion.div 
            variants={item} 
            whileTap={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
            className="bg-white rounded-xl relative overflow-hidden group hover:border-neutral-400 transition-colors border border-neutral-200 flex flex-col cursor-pointer h-[500px]"
            onClick={() => window.open('https://docs.google.com/presentation/d/1w_goKzq1Ag01Eu9_I1bqFNO6TH5eej7tj38Qp2UC34s/edit?usp=sharing', '_blank')}
          >
             <div className="p-10 pb-0 flex justify-between items-start z-10 relative">
                <h3 className="text-2xl font-bold text-neutral-900 max-w-lg font-khand">India's Largest Vernacular Parenting App</h3>
                <div className="flex items-center gap-2 shrink-0">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.healofy&hl=en_IN"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    className="flex items-center gap-1.5 text-[10px] font-mono text-neutral-500 bg-neutral-100 px-2.5 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-neutral-200 hover:text-neutral-900"
                  >
                    Live site <ExternalLink className="w-3 h-3" />
                  </a>
                  <div className="w-9 h-9 bg-neutral-100 rounded-full flex items-center justify-center group-hover:bg-neutral-900 transition-all">
                    <ArrowUpRight className="w-4 h-4 text-neutral-600 group-hover:text-white" />
                  </div>
                </div>
             </div>

             {/* Full Width Image Container with Padding */}
             <div className="w-full flex-1 mt-6 relative z-0 px-10 pb-10">
                <div className="w-full h-full rounded-2xl overflow-hidden shadow-sm">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_design-clarity-3/artifacts/qit233ua_Cards.jpg" 
                    alt="Healofy App Interface" 
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  />
                </div>
             </div>
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
};

export default HealofyGallery;
